function normalizeOrigin(origin: string): string {
  return origin.replace(/\/+$/, "");
}

export const PUBLICATION_FEED_TITLE = "Optimistic News";
export const PUBLICATION_FEED_DESCRIPTION =
  "The latest positive news articles curated by Optimistic News.";

export const PUBLICATION_FEED_TITLE_EN = "Optimistic News (English)";
export const PUBLICATION_FEED_DESCRIPTION_EN =
  "The latest positive English-language news articles curated by Optimistic News.";

export const PUBLICATION_FEED_TITLE_DE = "Optimistic News (Deutsch)";
export const PUBLICATION_FEED_DESCRIPTION_DE =
  "Die neuesten positiven deutschsprachigen Nachrichtenartikel von Optimistic News.";

export function buildAbsolutePublicationUrl(
  origin: string,
  path: string,
): string {
  return new URL(path, `${normalizeOrigin(origin)}/`).toString();
}

export function buildPublicationFeedPath(): string {
  return "/rss.xml";
}

export function buildPublicationFeedPathEn(): string {
  return "/rss-en.xml";
}

export function buildPublicationFeedPathDe(): string {
  return "/rss-de.xml";
}
